// @flow
import type {HOC} from 'recompose'
import type {State} from '../state'

import {connect} from 'react-redux'
import {hoistStatics} from 'recompose'

import {loginStatusSelector} from '../selectors'

const container: HOC<{loginStatus: boolean}, {}> = connect((state: State) => ({
  loginStatus: loginStatusSelector(state)
}))

export default hoistStatics(container)
